var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":_vm.url}},[_c('img',{staticClass:"logo-light",attrs:{"src":_vm.newlogo,"alt":"Hubthings"}}),_c('img',{staticClass:"logo-dark",attrs:{"src":_vm.darkLogo,"alt":"Hubthings"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }